import React, { HTMLInputTypeAttribute, useId, useState, forwardRef } from 'react';
import { Container, BotaoIcone } from './styles';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeHolder: string;
  animated?: boolean;
  type?: HTMLInputTypeAttribute;
  ativarToggleMostrarSenha?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, IProps>(
  ({ placeHolder, animated, ativarToggleMostrarSenha, type, id, style, className, ...rest }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const idGerado = useId();
    const idInput = id || idGerado;
    const mostrarToggle = type === 'password' && ativarToggleMostrarSenha;

    return (
      <Container $animated={animated} $comIcone={mostrarToggle} style={style} className={className}>
        <input
          {...rest}
          id={idInput}
          placeholder=' '
          type={showPassword ? 'text' : type || 'text'}
          ref={ref}
        />
        <label htmlFor={idInput}>
          {placeHolder}
          {rest.required && !rest.readOnly && <span className='obrigatorio' aria-hidden>*</span>}
        </label>
        {mostrarToggle && (
          <BotaoIcone
            type='button'
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </BotaoIcone>
        )}
      </Container>
    );
  }
);

export default FormInput;
